"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));
var _reactRouterDom = require("react-router-dom");
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
// import './MissionAlert.css'
var MissionAlert = /*#__PURE__*/function (_Component) {
  _inherits(MissionAlert, _Component);
  var _super = _createSuper(MissionAlert);
  function MissionAlert(props) {
    var _this;
    _classCallCheck(this, MissionAlert);
    _this = _super.call(this, props);
    _this.getStartingHands = function () {
      _this.setState({
        loading: true
      });
      var _this$props$playerRep = _this.props.playerReports,
        mission = _this$props$playerRep.mission,
        hitType = _this$props$playerRep.hitType;
      _this.props.apiService(_this.props.baseUrl + '/appUser/getStartingHands', {
        "Strategy": hitType
      }, function (hands) {
        var hand = {};
        hand['Early'] = hands[0]['Early'];
        hand['Late'] = hands[0]['Late'];
        hand['Mid'] = hands[0]['Mid'];
        _this.state.plyDtls.hand = hand;
        _this.state.plyDtls.callApi = false;
        _this.state.plyDtls.greenHands = null;
        _this.state.plyDtls.redHands = null;
        _this.state.plyDtls.plymission = {};
        _this.props.processHoleCards(mission.holeCards, hand, hitType, 'Late').then(function (tableData) {
          var handCount = tableData[0];
          var redHands = 0;
          var greenHands = 0;
          var result = '';
          Object.keys(handCount).forEach(function (key) {
            greenHands = greenHands + handCount[key].played + handCount[key].progressplayed;
            redHands = redHands + handCount[key].notPlayed;
          });
          _this.state.totalHands = greenHands + redHands;
          if (tableData[2].length == 50) {
            _this.state.totalHands = 50;
            greenHands / 50 * 100 >= 80 ? result = 'success' : result = 'fail';
            _this.setState({
              result: result
            });
            _this.setState({
              missionStatus: 'Completed'
            });
            _this.props.saveActivity({
              hit_page: 'MissionTooManyHands',
              hit_type: 'MissionComplete',
              hit_attribute1: result,
              hit_attribute2: greenHands + redHands,
              hit_attribute3: greenHands,
              hit_attribute4: redHands
            });
          }
          _this.state.plyDtls.greenHands = greenHands;
          _this.state.plyDtls.redHands = redHands;
          _this.state.plyDtls.plymission.handCount = tableData[0];
          _this.state.plyDtls.plymission.holeCards = tableData[1];
          _this.state.plyDtls.plymission.playerData = tableData[2];
          _this.forceUpdate();
          if (mission.missionStatus == 'Completed' && result != 'fail') _this.saveMissionDetails(result, greenHands, redHands);else _this.setState({
            loading: false
          });
        })["catch"](function (err) {
          _this.setState({
            loading: false
          });
          throw new Error(err);
        });
      }, function (err) {
        _this.setState({
          loading: false
        });
        throw new Error(err);
      });
    };
    _this.endMission = function () {
      var _this$props$playerRep2 = _this.props.playerReports,
        mission = _this$props$playerRep2.mission,
        hitType = _this$props$playerRep2.hitType,
        accountName = _this$props$playerRep2.accountName;
      _this.setState({
        loading: true
      });
      _this.props.saveActivity({
        hit_page: ' CashReportCard',
        hit_type: 'EndMissionButton',
        hit_attribute1: _this.state.result
      });
      _this.props.apiService(_this.props.baseUrl + '/missions/updateMission', {
        'accountName': accountName,
        'missionName': mission.name,
        'selectedType': hitType,
        "currentMissionStatus": 'EndMission',
        'userType': localStorage.getItem('loggedInType'),
        'startDate': mission.startDate
      }, function (data) {
        return window.location.reload();
      }, function (err) {
        return _this.setState({
          loading: false
        });
      });
    };
    _this.saveMissionDetails = function (result, greenHands, redHands) {
      var _this$props$playerRep3 = _this.props.playerReports,
        mission = _this$props$playerRep3.mission,
        hitType = _this$props$playerRep3.hitType,
        accountName = _this$props$playerRep3.accountName;
      _this.setState({
        loading: true
      });
      _this.props.apiService(_this.props.baseUrl + '/missions/updateMission', {
        'accountName': accountName,
        'missionName': mission.name,
        'selectedType': hitType,
        "currentMissionStatus": 'Completed',
        "result": result,
        "greenHands": greenHands,
        "redHands": redHands,
        'userType': localStorage.getItem('loggedInType'),
        'startDate': mission.startDate
      }, function (data) {
        _this.setState({
          loading: false
        });
      }, function (data) {
        _this.setState({
          loading: false
        });
      });
    };
    _this.TypeFix = function (_) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        "data-e2e": "alertBox",
        style: {
          borderRadius: "4px",
          // backgroundColor: "#FFEFDF",
          display: 'grid',
          gridTemplateColumns: 'auto',
          gridRowGap: '3px',
          padding: "10px",
          border: "2px solid rgb(251, 221, 184)"
        }
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        name: "fas fa-exclamation-triangle",
        style: {
          display: 'inline'
        }
      }), /*#__PURE__*/_react["default"].createElement("b", {
        style: {
          fontSize: "16px",
          height: '22px',
          lineHeight: "22px",
          paddingLeft: '7px'
        }
      }, _this.props.i18next.t("lable.ALERT"), "!")), /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          marginTop: "5px",
          marginBottom: "5px"
        }
      }, " ", _this.props.i18next.t("lable.youArePlTooManyHands")), /*#__PURE__*/_react["default"].createElement("a", {
        "data-e2e": "goToMission",
        className: "pulseFTPbutton mg-btn saffron",
        onClick: _this.nextPage,
        style: {
          width: "165px",
          textDecoration: 'none',
          cursor: 'pointer',
          fontWeight: "bold"
        }
      }, _this.props.i18next.t("lable.fixThisProblem")));
    };
    _this.TypeStarted = function () {
      var _this$state$plyDtls = _this.state.plyDtls,
        greenHands = _this$state$plyDtls.greenHands,
        redHands = _this$state$plyDtls.redHands;
      var green = (greenHands / 50 * 100).toFixed(2);
      var red = (redHands / 50 * 100).toFixed(2);
      var mission = _this.props.playerReports.mission;
      return /*#__PURE__*/_react["default"].createElement("div", {
        "data-e2e": "missionStart",
        style: {
          borderRadius: "4px",
          // backgroundColor: "#FFEFDF",
          display: 'grid',
          gridTemplateColumns: 'auto',
          gridRowGap: '3px',
          padding: "10px"
        }
      }, /*#__PURE__*/_react["default"].createElement("b", {
        style: {
          fontFamily: "Roboto",
          fontSize: "16px",
          height: '22px',
          lineHeight: "22px"
        }
      }, mission.missionStatus === 'Inprogress' ? _this.props.i18next.t("lable.missionInProgress") : _this.props.i18next.t("lable.startingHandMissionComplete")), /*#__PURE__*/_react["default"].createElement("p", {
        style: {
          fontFamily: "Roboto"
        },
        "data-e2e": "handsPlayData"
      }, _this.props.i18next.t("lable.startingHandMissionComplete") + " " + greenHands + " " + _this.props.i18next.t("lable.green") + " & " + redHands + " " + his.props.i18next.t("lable.red") + "."), /*#__PURE__*/_react["default"].createElement(DualProgressBar, {
        greenHands: _this.state.plyDtls.greenHands,
        redHands: _this.state.plyDtls.redHands,
        bars: [{
          text: "".concat(green, "%"),
          progress: "".concat(green, "%"),
          bgColor: "#3BD989"
        }, {
          text: "".concat(red, "%"),
          progress: "".concat(red, "%"),
          bgColor: "#FC5C65"
        }]
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1fr',
          gridColumnGap: '5px'
        }
      }, /*#__PURE__*/_react["default"].createElement("button", {
        "data-e2e": "missionView",
        onClick: _this.nextPage,
        className: "btn",
        style: {
          backgroundColor: "#EB602E",
          color: '#ffffff'
        }
      }, _this.props.i18next.t("lable.view")), mission.missionStatus == 'Completed' ? /*#__PURE__*/_react["default"].createElement("button", {
        "data-e2e": "missionRestart",
        className: "btn",
        onClick: _this.restartMission,
        style: {
          backgroundColor: "#EB602E",
          color: '#ffffff'
        }
      }, _this.props.i18next.t("lable.restart")) : null, mission.missionStatus == 'Completed' ? /*#__PURE__*/_react["default"].createElement("button", {
        "data-e2e": "missionEnd",
        className: "btn",
        onClick: _this.endMission
      }, _this.props.i18next.t("lable.endMission")) : null));
    };
    _this.TypeReportSummary = function (_) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          borderRadius: "4px",
          display: 'grid',
          gridTemplateColumns: 'auto',
          gridRowGap: '3px',
          padding: "10px"
        }
      }, /*#__PURE__*/_react["default"].createElement("b", {
        style: {
          fontSize: "16px",
          height: '22px',
          lineHeight: "22px"
        }
      }, _this.props.i18next.t("lable.reportSummary")), /*#__PURE__*/_react["default"].createElement("p", null, _this.props.i18next.t("lable.goodReportSomeLeakesFirst") + "B" + _this.props.i18next.t("lable.goodReportSomeLeakesSecond")));
    };
    _this.nextPage = function () {
      _this.props.saveActivity({
        hit_page: "".concat(_this.props.gameType, "ReportCard"),
        hit_type: ['Inprogress', 'Completed', 'Restart'].indexOf(_this.state.missionStatus) != -1 ? 'viewMissionButton' : 'ReportCardClickToFix',
        hit_attribute1: _this.state.plyDtls.greenHands,
        hit_attribute2: _this.state.plyDtls.redHands,
        hit_attribute3: _this.state.plyDtls.greenHands + _this.state.plyDtls.redHands
      });
      if (_this.props.isLiveview) {
        _this.props.toggleMissionModal(true);
      } else {
        _this.props.history.push({
          pathname: '/missions',
          state: {
            missionProps: _objectSpread(_objectSpread({}, _this.state.plyDtls), {
              plymission: _this.props.playerReports.mission,
              result: _this.state.result,
              missionStatus: _this.state.missionStatus
            })
          }
        });
      }
    };
    _this.restartMission = function () {
      var _this$props$playerRep4 = _this.props.playerReports,
        mission = _this$props$playerRep4.mission,
        hitType = _this$props$playerRep4.hitType,
        accountName = _this$props$playerRep4.accountName,
        gameType = _this$props$playerRep4.gameType;
      _this.props.saveActivity({
        hit_page: "".concat(gameType, "ReportCard"),
        hit_type: 'RestartMissionButton',
        hit_attribute1: _this.state.result
      });
      _this.props.apiService(_this.props.baseUrl + '/missions/restartMission', {
        'missionRestartDate': _moment["default"].utc().format('YYYY-MM-DD HH:mm:ss'),
        'accountName': accountName,
        'missionName': mission.name,
        'selectedType': hitType,
        "status": 'Inprogress',
        'currentMissionStatus': 'Cancelled',
        "greenHands": _this.state.plyDtls.greenHands,
        "redHands": _this.state.plyDtls.redHands,
        "result": _this.state.result,
        'userType': localStorage.getItem('loggedInType'),
        'startDate': mission.startDate
      }, function (data) {
        window.location.reload();
      }, function (err) {
        console.log(err);
      });
    };
    _this.state = {
      plyDtls: {},
      loading: false,
      title: null,
      totalHands: 0,
      result: '',
      missionStatus: ''
    };
    return _this;
  }
  _createClass(MissionAlert, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        missionStatus: ['Inprogress', 'Completed', 'Restart'].indexOf(this.props.playerReports.mission.missionStatus) != -1 ? 'Inprogress' : 'pre-start'
      });
      if (['Inprogress', 'Completed', 'Restart'].indexOf(this.props.playerReports.mission.missionStatus) != -1 && !this.props.loading) this.getStartingHands();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        "data-e2e": "missionAlertBox",
        className: "missionAlertBox",
        style: {
          borderColor: this.state.missionStatus === "Completed" ? this.state.result === "success" ? "#3BD989" : "#FC5C65" : "#EB602E"
        }
      }, ['Inprogress', 'Completed', 'Restart'].indexOf(this.state.missionStatus) != -1 ? /*#__PURE__*/_react["default"].createElement(this.TypeStarted, null) : /*#__PURE__*/_react["default"].createElement(this.TypeFix, null));
    }
  }]);
  return MissionAlert;
}(_react.Component);
var DualProgressBar = function DualProgressBar(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-e2e": "progressBarData",
    className: "progress",
    style: {
      height: "15px"
    }
  }, props.bars.map(function (bar) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "progress-bar",
      style: {
        width: bar.progress,
        backgroundColor: bar.bgColor
      }
    }, bar.text);
  }));
};
var _default = (0, _reactRouterDom.withRouter)(MissionAlert);
exports["default"] = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/mygame-components/dist/ReportCards/MissionAlert.js
 ** module id = 2386
 ** module chunks = 0
 **/